import { DWTableStatusColor } from 'src/components/table-status-color';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWTableStatusColor.displayName, DWTableStatusColor);

export default DWTableStatusColor;

export { DWTableStatusColor };
